import BaseService from "./BaseService";
import {
  ActivityRequest,
  ActivityResponse,
  ActivitiesResponse,
  PaginatedActivitiesResponse
} from "./mappers/ActivityMapper";
import store from "@/store";

class ActivityService extends BaseService {
  constructor() {
    super();
  }

  createActivity(data) {
    store.dispatch("app/setPendingChanges", false);
    return this.post(`activities/`, ActivityRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityResponse(data));
  }

  createCompanyActivity(id, data) {
    store.dispatch("app/setPendingChanges", false);
    return this.post(`companies/${id}/activities/`, ActivityRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityResponse(data));
  }

  getActivitiesByCompanyAndIsYearly(id, page = 1, pageSize = 5, year = "", department = "") {
    return this.get(
      `companies/${id}/activities/?is_yearly_activity=1&page=${page}&page_size=${pageSize}&year=${year}&department=${department}`
    ).then((response) => PaginatedActivitiesResponse(response.data));
  }

  getActivitiesByCompany(
    id,
    page = 1,
    pageSize = 5,
    year = "",
    status = "",
    department = "",
    protocol = "",
    protocol_group = "",
    questionnaire_type = "",
    person = "") {
    return this.get(`companies/${id}/activities/?page=${page}&page_size=${pageSize}&year=${year}&status=${status}&department=${department}&protocol=${protocol}&protocol_group=${protocol_group}&questionnaire_type=${questionnaire_type}&person=${person}`).then((response) =>
      PaginatedActivitiesResponse(response.data)
    );
  }

  getActivitiesByCompany2(
    id,
    page = 1,
    pageSize = 5,
    year = "",
    status = [],
    category = "",
    search = "") {
    let unassigned_category = category == "unassigned" ? 1 : "";
    return this.get(`companies/${id}/activities/?page=${page}&page_size=${pageSize}&year=${year}&status=${status}&category=${category}&search=${search}&unassigned_category=${unassigned_category}`).then((response) =>
      PaginatedActivitiesResponse(response.data)
    );
  }

  getActivitiesByMe(
    page = 1,
    pageSize = 5,
    year = "",
    status = [],
    category = "",
    search = "",
    is_yearly_activity = ""
  ) {
    let unassigned_category = category == "unassigned" ? 1 : "";
    is_yearly_activity = is_yearly_activity == true ? is_yearly_activity : "";
    return this.get(
      `my/activities/?page=${page}&page_size=${pageSize}&year=${year}&status=${status}&category=${category}&search=${search}&unassigned_category=${unassigned_category}&is_yearly_activity=${is_yearly_activity}`
    ).then((response) => PaginatedActivitiesResponse(response.data));
  }

  getActivitiesBySystem(page = 1, pageSize = 5, search = "") {
    return this.get(`system/activities/?page=${page}&page_size=${pageSize}&search=${search}`).then((response) =>
      PaginatedActivitiesResponse(response.data)
    );
  }

  getActivitiesBySystemAndInPreset(presetId, page = 1, pageSize = 5) {
    return this.get(`system/activities/?in_${presetId}_preset=1&page=${page}&page_size=${pageSize}`).then((response) =>
      PaginatedActivitiesResponse(response.data)
    );
  }

  copyActivitiesBySystemAndInPreset(presetId, destinationYear) {
    return this.post(`system/activities/copy/${presetId}/${destinationYear}/`).then((response) => response.data);
  }

  copyYearlyActivitiesFromPreviousYear(destinationYear) {
    return this.post(`my/company/copy-yearly-activities-from-previous-year/${destinationYear}/`).then(
      (response) => response.data
    );
  }

  copyYearlyActivitiesFromSelectedYear(selectedYear, destinationYear) {
    return this.post(`my/company/copy-yearly-activities-from-previous-year/${destinationYear}/`).then(
      (response) => response.data
    );
  }

  getActivity(id) {
    return this.get(`activities/${id}/`)
      .then((response) => response.data)
      .then((data) => ActivityResponse(data));
  }

  getActivities() {
    return this.get(`activities/`)
      .then((response) => response.data)
      .then((data) => ActivitiesResponse(data));
  }

  getActivityYears(id) {
    return this.get(`companies/${id}/activityyears/`).then((response) => response.data);
  }

  updateActivity(id, data) {
    store.dispatch("app/setPendingChanges", false);
    return this.patch(`activities/${id}/`, ActivityRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityResponse(data));
  }

  deleteActivity(id) {
    store.dispatch("app/setPendingChanges", false);
    return this.delete(`activities/${id}/`);
  }

  getRecruitedCompanyActivitiesByCompanyAndIsYearly(companyId, page = 1, pageSize = 5, year = "") {
    return this.get(
      `my/company/recruited-companies/${companyId}/activities/?is_yearly_activity=1&page=${page}&page_size=${pageSize}&year=${year}`
    ).then((response) => PaginatedActivitiesResponse(response.data));
  }

  getRecruitedCompanyActivity(id) {
    return this.get(`my/company/recruited-companies/activities/${id}/`).then((response) =>
      ActivityResponse(response.data)
    );
  }
}

export default new ActivityService();
